import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ApiControllerService } from './api-controller.service';

export interface IReservationConfiguration
{
    id?: string;
    storeId: string;
    useWaitlist: boolean;
    useReservation: boolean;
    useFloorplan: boolean;
    usePrepay: boolean;
    enableIframeBg: boolean;
    numTables: number;
    numSeats: number;
}

@Injectable({
    providedIn: 'root'
})
export class ReservationConfigurationService {

  constructor(private http: HttpClient,
      private setting: SettingService,
    private apiController: ApiControllerService) { }

  findReservationConfiguration(storeId: string): Observable<IReservationConfiguration> {
    return Observable.create(o => {
        /* this.http.post(this.setting.apiUrl('reservationConfiguration/findReservationConfiguration'), {
            storeId: storeId
        }).subscribe((data: any) => {
            o.next(data);
            o.complete();
        }); */

        this.apiController.post(this.setting.apiUrl('reservationConfiguration/findReservationConfiguration'), {
            storeId: storeId
        }).subscribe((data: any) => {
            o.next(data);
            o.complete();
        });
    })
  }
}